import { render } from "./pageone.vue?vue&type=template&id=30dfc56d&scoped=true"
import script from "./pageone.vue?vue&type=script&lang=js"
export * from "./pageone.vue?vue&type=script&lang=js"

import "./pageone.vue?vue&type=style&index=0&id=30dfc56d&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dfc56d"]])

export default __exports__